"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
var _dialog, _dialog2;
var _default = exports.default = {
  otherControlledFile: {
    qualityFile: {
      rules: {
        orderNum: 'Enter up to 12 integers and 5 decimals'
      },
      vesselControlledFile: 'Vessel Supportive File',
      otherControlledFile: 'Support Manual/Plan',
      controlledFile: 'Support Manual/Plan Maintenance',
      otherControlledDocuments: 'Catalog for Other Controlled DOC.',
      fileNo: 'DOC. No.',
      fileName: 'DOC. Name',
      enterFileNo: 'Please enter the DOC. No.',
      enterFileName: 'Please enter the DOC. Name',
      fileInformation: 'File Information',
      recordInformation: 'Record Information',
      historicalVersion: 'History Version',
      linkFile: 'Link File',
      addLinkFile: 'Add Link File',
      updateLinkFile: 'Update Link File',
      filter: {
        manageCompany: 'Company',
        vessel: 'Vessel',
        dept: 'Dept',
        uploadDate: 'Upload Date',
        yes: 'Y',
        no: 'N',
        examination: 'Involve Exam.',
        async: 'Vessel Shore Sync',
        isValid: 'Is Valid',
        valid: 'Valid',
        invalid: 'Invalid',
        status: 'Status'
      },
      button: {
        editCatalog: 'Catalog Management',
        editVersion: 'Version Management',
        addQualityFile: 'Add DOC.',
        queryQualityFile: 'Quary DOC.',
        editQualityFile: 'Revise DOC.',
        editCatalogHistory: 'Revised DOC. History',
        btnPublish: 'Release',
        fileSearch: 'Search',
        addLinkFile: 'Add Link File'
      },
      table: (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({
        linkUrl: 'Link Url',
        dispOrder: 'Display Order',
        qualityFileNo: 'File No.',
        qualityFileName: 'File Name',
        qualityFileType: 'File Type',
        qualityFileStatus: 'Status',
        qualityFileDate: 'Effective Date',
        learnDeadline: 'Learned Deadline',
        learnDetail: 'Learned',
        feedbackDeadline: 'Implemented Deadline',
        uploadAttach: 'Upload Attachments',
        actual: 'Implementation',
        attachmentsInfoId: 'Attachment',
        timeChoose: 'Select time ',
        vessel: 'Vessel',
        dept: 'Dept',
        responsibleDepartment: 'Responsible Dept',
        qualityVersion: 'Version',
        async: 'Vessel Shore Sync',
        examination: 'Involve Exam.',
        mainBody: 'File Text',
        fileOrLink: 'File/Link'
      }, "attachmentsInfoId", 'Attachment'), "uploader", 'Uploaded by'), "uploadDate", 'Uploaded Date'), "fileStatus", 'status'),
      dialog: (_dialog = {
        dispOrder: 'Display Order',
        company: 'Company',
        qualityFileNo: 'File No.',
        qualityFileNoCn: 'File No. (Cn)',
        qualityFileNameCn: 'DOC. Name(Cn)',
        qualityFileNameEn: 'DOC. Name(En)',
        qualityVersion: 'Major Version',
        vesselCode: 'Vessel',
        linkUrl: 'Link Url',
        responsibleDepartment: 'Responsible Dept',
        syncFlag: 'Vessel Shore Sync',
        sync: 'Y',
        unSync: 'N',
        exam: 'Y',
        unExam: 'N',
        effectiveFlag: 'Effective',
        effective: 'Y',
        unEffective: 'N',
        overdueDate: 'Over Due Date',
        selectOverdueDate: 'Please Select Over Due Date',
        relaxQualityFile: 'Related DOC.',
        mainBody: 'File Text',
        upMainBody: 'Upload File',
        attachmentsInfoId: 'Attachment',
        uploadAttachment: 'Upload Attachment',
        catalog: 'Catalog',
        sysPostId: 'Learner of ship',
        examFlag: 'Involve Exam.',
        companyName: 'Company',
        enterCompany: 'Please select company',
        catalogNameCn: 'Catalog Name',
        lastModifyTime: 'Modify Date',
        catalogRemark: 'Remark',
        parentName: 'Parent Catalog'
      }, (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_dialog, "catalogNameCn", 'Catalog Name(Cn)'), "catalogNameEn", 'Catalog Name(En)'), "dispOrder", 'Display Order'), "editCatalogItem", 'Catalog'), "usedScope", 'Used Scope'), "usedShore", 'Shore Used'), "vesselShoreUsed", 'Vessel Shore Used'), "vesselUsed", 'Vessel Used'), "qualityCatalog", 'Quality Catalog'), "valid", 'Valid'), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_dialog, "invalid", 'Invalid'), "uploadLt", 'File size cannot exceed 20m'), "uploadPdf", 'Only. pdf files can be uploaded'))
    },
    qualityRecord: {
      vesselControlledFile: 'Vessel Supportive File',
      qualityRecord: 'Additional Form Maintenance',
      fileInformation: 'DOC. Info.',
      recordInformation: 'Form Info.',
      historicalVersion: 'Revised History',
      filter: {
        fileNo: 'Form No.',
        fileNoName: 'DOC. No./Name',
        enterFileNo: 'Please enter the No.',
        fileName: 'Form Name',
        enterFileName: 'Please enter the DOC. Name',
        manageCompany: 'Company',
        dept: 'Dept',
        involveDept: 'Involve Dept',
        role: 'Involve Post',
        deptMonitor: 'Monitor Dept',
        roleMonitor: 'Monitor Post',
        circleWork: 'Circle Work',
        syncFlag: 'Vessel Shore Sync',
        yes: 'Y',
        no: 'N'
      },
      table: {
        qualityRecordNo: 'Form No.',
        qualityRecordName: 'Form Name',
        qualityRecordNameCn: 'Form Name(Cn)',
        qualityRecordNameEn: 'Form Name(En)',
        qualityRecordVersion: 'Major Version',
        qualityReviseVersion: 'Edition Version',
        qualityRecordDate: 'Effective Date',
        qualityFileStatus: 'Status',
        sysPostId: 'Related Position/Rank',
        validFlag: 'Status',
        recordLocation: 'Storage Location',
        recordSaveTime: 'Storage Term',
        attachmentsName: 'Related DOC. ',
        index: 'No.',
        qualityFileName: 'DOC. Name',
        qualityFileDate: 'Effective Date',
        qualityDueDate: 'Expired Date'
      },
      dialog: (_dialog2 = {
        addTitle: 'Add Record',
        editTitle: 'Edit Record',
        queryTitle: 'Query Record',
        circleFlag: 'Circle Remind',
        recordRootId: 'ID',
        qualityRecordNo: 'Form No.',
        qualityRecordVersion: 'Major Version',
        qualityReviseVersion: 'Edition Version',
        qualityRecordNameCn: 'Form Name(Cn)',
        qualityRecordNameEn: 'Form Name(En)',
        recordSaveTime: 'Storage Term',
        syncFLag: 'Sync(Ship & Shore)',
        qualityRecordDept: 'Created By',
        sysOrgId: 'Related Dept.',
        sysPostId: 'Related Position/Rank',
        yes: 'Y',
        no: 'N',
        qualityRecordDate: 'Effective Date',
        qualityFileId: 'Related DOC.',
        inputCircle: 'Fill In Circle',
        createOffice: 'Created by',
        monitorPost: 'Monitor Post',
        startPost: 'Start by Post.',
        remindDate: 'Remind Date'
      }, (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_dialog2, "circleFlag", 'Circle Remind'), "monitorRemind", 'Monitor Remind'), "tableTemplate", 'Record Templage'), "sysPostId", 'Related Position/Rank'), "recordLocation", 'Storage Location'), "uploadAttachment", 'Upload File'), "day", 'Day'), "vessel", 'Vessel'), "relatedFileType", 'Related File Type'), "qualityFile", 'Quality File'), (0, _defineProperty2.default)((0, _defineProperty2.default)(_dialog2, "supportFile", 'Supportive File'), "rulesCirculars", 'Rules & Circulars'))
    }
  }
};